
import { Nav } from './components/nav'
import { Module05Slider } from './modules/module-05-slider'
import { Module06Logos } from './modules/module-06-logos'
import { Module08Chiffres } from './modules/module-08-chiffres'
import { Module09Chrono } from './modules/module-09-chrono'
import { Module13Valeurs } from './modules/module-13-valeurs'
import { Module15Temoignage } from './modules/module-15-temoignage'

// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

class App {
  constructor() {
    const nav = new Nav;
    
    if(document.querySelector('.module-05-slider')) {
      const module05Slider = new Module05Slider;
    }
    if(document.querySelector('.module-06-logos')) {
      const module06Logos = new Module06Logos;
    }

    if(document.querySelector('.module-08-chiffres')) {
      const module08Chiffres = new Module08Chiffres;
    }
    
    if(document.querySelector('.module-09-chrono')) {
      const module09Chrono = new Module09Chrono;
    }
    
    if(document.querySelector('.module-13-valeurs')) {
      const module13Valeurs = new Module13Valeurs;
    }
    
    if(document.querySelector('.module-15-temoignage')) {
      const module15Temoignage = new Module15Temoignage;
    }
    // if(document.querySelector('.dropdown')) {
    //   const dropdown = new DropDown;
    // }
    // if(document.querySelector('.popup')) {
    //   const popup = new PopUp;
    // }
  }
}

window.onload = function() {
  let app = new App();
};
